export default __webpack_public_path__ + "static/media/4.0334ce9c.png";